import {Component, OnDestroy, OnInit} from '@angular/core';
import {context} from '../../contexts/context';
import {Router} from '@angular/router';
import {BoutonSaisonnier} from '../models/boutonsaisonnier.model';
import {CnafContacterMaCafService} from '../services/contactermacaf.service';
import { BOUTONS_SAISONNIERS } from '../../config/boutons-saisonniers.config';
import { Subscription } from 'rxjs';

declare let changeContextChatbotAppliMobile: (rubrique: string, dialog: string) => void;
declare let reinitContextChatbotAppliMobile: () => void;

@Component({
  selector: 'app-contactermacaf-motifsdecontact',
  templateUrl: './contactermacaf-motifsdecontact.component.html',
  styleUrls: ['./contactermacaf-motifsdecontact.component.css']
})
export class ContactermacafMotifsdecontactComponent implements OnInit,OnDestroy{

  isContexteMobile = false;
  etat!: string;
  boutonsSaisonniers = BOUTONS_SAISONNIERS;
  boutonSaisonnierActuel!: BoutonSaisonnier | undefined;
  numeroAComposer!: string;
  chapitre3!: string | undefined;
  delaiAttenteChargeeSub$!: Subscription;
  constructor(private router: Router,
              private cnafContacterMaCafService: CnafContacterMaCafService) {

  }
  ngOnDestroy(): void {
    this.delaiAttenteChargeeSub$?.unsubscribe();
  }
  
  ngOnInit() : void {
    this.etat = 'loaded';
    this.isContexteMobile = context.type === 'mobile';

    this.boutonSaisonnierActuel = this.getBoutonSaisonnierActuel();

    if (typeof changeContextChatbotAppliMobile === 'function') {
      changeContextChatbotAppliMobile('SVI_VISUEL', 'testsvicontext');
    }
    this.delaiAttenteChargeeSub$ = this.cnafContacterMaCafService.delaiAttenteChargee.subscribe({
      next: (data: any) => {
        if(data.chargementTermine)
         this.etat =  'loaded';
      }
    });   
  }

  getBoutonSaisonnierActuel(): BoutonSaisonnier | undefined{
    const today = this.cnafContacterMaCafService.getDateEnv();
    return this.boutonsSaisonniers.find(bouton => {
      const debut = this.parseDate(bouton.dateDebut);
      const fin = this.parseDate(bouton.dateFin);
      return today >= debut && today <= fin;
    });
  }

  parseDate(dateStr : string): Date{
    const [day, month] = dateStr.split('/').map(num => parseInt(num.trim(), 10));
    return new Date(new  Date().getFullYear(), month - 1, day);
  }

  retourVersAccueil(event: Event) {
    event.preventDefault();
    if (typeof reinitContextChatbotAppliMobile === 'function') {
      reinitContextChatbotAppliMobile();
    }
    this.router.navigate(['/contactcaf']);
  }

  appelerMaCaf(): void {
    if(!this.chapitre3) {
      this.chapitre3 = this.boutonSaisonnierActuel?.tagChapitre3;
    }
    this.etat = 'loading';
    this.cnafContacterMaCafService.appeldelaiAttente(true,this.chapitre3);
  }
}
